import BalanceSheetActions from './actions';

const INITIAL_STATE = {
  data: {},
  isProcessing: false,
  isError: false,
  errorMessage: [],
  form:{},
  isNewRecord:false,
  showModal:false,
  onSubmit:false,
  single:null,
  helperBalanceSheet:[],
  errorInternal:false,
  printBalanceSheet:null
};

function BalanceSheetReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case BalanceSheetActions.RESET_LIST:
      return { ...state,errorInternal:false,onSubmit:false, isProcessing: false,single:null, form:INITIAL_STATE.form,data:{}};
    case BalanceSheetActions.NEW_DATA:
      return { ...state,errorInternal:false,onSubmit:false, isProcessing: false,single:null, errorMessage:[],form:INITIAL_STATE.form,isNewRecord:true,showModal:true};
    case BalanceSheetActions.UPDATE_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: false, single:null,isNewRecord:false};
    case BalanceSheetActions.VIEW_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: false, single:action.payload,errorMessage:[],isNewRecord:false,showModal:true};
    case BalanceSheetActions.RESET_DATA:
      return { ...state,errorInternal:false,onSubmit:false, isProcessing: false, form:INITIAL_STATE.form,showModal:false};
    case BalanceSheetActions.DELETE_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: false, form:INITIAL_STATE.form,showModal:false};
    case BalanceSheetActions.ON_SUBMIT:
      return { ...state, errorInternal:false,onSubmit:true};
    case BalanceSheetActions.SHOW_DATA:
      return { ...state, errorInternal:false,onSubmit:false, isError: false, data: action.payload, errorMessage: [],isProcessing:false };
    case BalanceSheetActions.ERROR_DATA:
      return { ...state, errorInternal:false, isError: true,onSubmit:false,  errorMessage: action.payload,isProcessing:false };
    case BalanceSheetActions.SUCCESS_DATA:
      return { ...state,errorInternal:false,onSubmit:false, isError: false, showModal:false,form:INITIAL_STATE.form , onSubmit:false};
    case BalanceSheetActions.PROCESS_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: true, isError: false,isSuccess:false};
    case BalanceSheetActions.GET_HELPER_BALANCESHEET:
      return { ...state,errorInternal:false, isError: false,isSuccess:false,onSubmit:false,helperBalanceSheet:action.payload};
    case BalanceSheetActions.ERROR_SERVER:
      return { ...state,  isError: false, errorInternal:true, onSubmit:false,  errorMessage: action.payload, isProcessing:false };
    case BalanceSheetActions.BEFORE_PRINT_BALANCESHEET:
      return { ...state,errorInternal:false,  isError: false,isSuccess:false,onSubmit:false,printBalanceSheet:null,isProcessing:true};
    case BalanceSheetActions.PRINT_BALANCESHEET:
      return { ...state,errorInternal:false,  isError: false,isSuccess:false,onSubmit:false,printBalanceSheet:action.payload,isProcessing:false};
       
    default:
      return state;
    }
}

export default BalanceSheetReducer;
